<form (submit)="onSubmit($event)" data-testid="pwd-form-update">
  <dx-form
    id="form"
    [formData]="newPassword"
    [readOnly]="false"
    [showColonAfterLabel]="false"
    [showValidationSummary]="false"
    labelLocation="top"
    [elementAttr]="{ 'data-testid': 'pwd-form-main' }"
  >
    <dxi-item
      dataField="password"
      [editorOptions]="{ mode: 'password', placeholder: 'Enter new password' }"
      helpText="Min. 8 characters, with upper, lower, number, and special."
    >
      <dxo-label text="New Password"></dxo-label>
      <div data-testid="pwd-input-new-password" style="display: none;"></div>
      <dxi-validation-rule message="Password is required" type="required"></dxi-validation-rule>
      <dxi-validation-rule
        [min]="8"
        message="Must be minimum 8 characters"
        type="stringLength"
      ></dxi-validation-rule>
      <dxi-validation-rule
        [max]="64"
        message="Must be max 64 characters"
        type="stringLength"
      ></dxi-validation-rule>
      <dxi-validation-rule
        [pattern]="passwordRuleLower"
        message="At least one lower case letter"
        type="pattern"
      ></dxi-validation-rule>
      <dxi-validation-rule
        [pattern]="passwordRuleUpper"
        message="At least one upper case letter"
        type="pattern"
      ></dxi-validation-rule>
      <dxi-validation-rule
        [pattern]="passwordRuleNumber"
        message="At least one numeric digit"
        type="pattern"
      ></dxi-validation-rule>
      <dxi-validation-rule
        [pattern]="passwordRuleSpSymbol"
        message="At least one special character"
        type="pattern"
      ></dxi-validation-rule>
    </dxi-item>

    <dxi-item
      dataField="match_password"
      editorType="dxTextBox"
      [editorOptions]="{ mode: 'password', placeholder: 'Confirm your new password' }"
    >
      <dxo-label text="Confirm New Password"></dxo-label>
      <div data-testid="pwd-input-confirm-password" style="display: none;"></div>
      <dxi-validation-rule
        type="required"
        message="Confirm Password is required"
      ></dxi-validation-rule>
      <dxi-validation-rule
        type="compare"
        [comparisonTarget]="passwordComparison"
        message="Passwords do not match"
      ></dxi-validation-rule>
    </dxi-item>

    <dxi-item itemType="group" cssClass="password-update-footer">
      <dx-button
        [text]="buttonOptions.text"
        [type]="buttonOptions.type"
        [useSubmitBehavior]="buttonOptions.useSubmitBehavior"
        [width]="140"
        [elementAttr]="{ 'data-testid': 'pwd-btn-submit' }"
      ></dx-button>
    </dxi-item>
  </dx-form>
</form>
